import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'destroyFilter', pure: false })
export class DestroyFilterPipe implements PipeTransform {
  transform(list: any[]): any {
    return list
      ? list.filter((item) => {
          return !item._destroy;
        })
      : [];
  }
}
